﻿
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Config } from '../config/config';
import * as StackTrace from 'stacktrace-js';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';


declare var config: Config;


interface ApplicationError {
    url: string;
    stackTrace: string;
    message: string;
}


/**
 * Send error message to the server
 */

@Injectable()
export class ErrorLogService {

    /**
     * Get the api url endpoint
     */
    protected get endpoint(): string {
        return config.apiUrl;
    };

    constructor(private http: HttpClient, private location: LocationStrategy) { }

    public error = (error: Error) => {

        const url = this.location instanceof PathLocationStrategy ? this.location.path() : '';
        const message = error.message ? error.message : error.toString();

        console.error(error);


        //get the stack trace, lets grab the last 10 stacks only
        return StackTrace.fromError(error, { offline: true })
            .then(stackframes => stackframes.splice(0, 20).map(x => x.toString()).join('\n'))
            //then send error to the server
            .then(stackTrace => {

                var data: ApplicationError = {
                    url,
                    message,
                    stackTrace
                };
                
                return this.http.post<ApplicationError>(this.endpoint + `/error`, data)
                    .toPromise()
                    .catch(x => {
                        console.log('Unable to log data:', data);
                        console.log('Reason:', x);
                    });
            });

    }
}